import React from "react";
import Navbar from "@/components/zorba/Navbar";
import Hero from "@/components/zorba/Hero";
import About from "@/components/zorba/About";
import Restauracion from "@/components/zorba/Restauracion";
import Experiences from "@/components/zorba/Experiences";
import Gallery from "@/components/zorba/Gallery";
import VideoCies from "@/components/zorba/VideoCies";
import Portonovo from "@/components/zorba/Portonovo";
import WhyChoose from "@/components/zorba/WhyChoose";
import Prensa from "@/components/zorba/Prensa";
import Contact from "@/components/zorba/Contact";
import Footer from "@/components/zorba/Footer";

export default function Landing() {
  return (
    <div className="min-h-screen bg-background text-foreground" data-testid="landing-page">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Restauracion />
        <Experiences />
        <Gallery />
        <VideoCies />
        <Portonovo />
        <WhyChoose />
        <Prensa />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
